import FullscreenSearchBox from './FullscreenSearchBox';

export default FullscreenSearchBox;
